import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "dropdown-container" }
const _hoisted_2 = { class: "dropdown-label" }
const _hoisted_3 = { class: "dropdown-list" }
const _hoisted_4 = { class: "checkbox-wr" }
const _hoisted_5 = ["value", "onChange", "checked"]
const _hoisted_6 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["slot-wrapper", { active: $setup.showDropDown }]),
      onClick: $setup.toggleDropdown
    }, [
      _createElementVNode("label", _hoisted_2, _toDisplayString($setup.selectedLabel), 1)
    ], 2)), [
      [_directive_click_outside, $setup.closeDropdown]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["dropdown", $props.placement])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "dropdown-option",
          href: "#",
          onClick: _withModifiers($setup.toggleCheckAll, ["prevent"])
        }, _toDisplayString($setup.areAllChecked ? "Uncheck All" : "Check All"), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "dropdown-option",
            key: option.value,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, [
                _createElementVNode("input", {
                  type: "checkbox",
                  value: option.value,
                  onChange: ($event: any) => ($setup.toggleOption(option.value)),
                  checked: $setup.selectedOptions.includes(option.value)
                }, null, 40, _hoisted_5),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "box" }, null, -1)),
                _createElementVNode("p", _hoisted_6, _toDisplayString(option.label), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ], 2), [
      [_vShow, $setup.showDropDown]
    ])
  ]))
}